<div
    class="input-field-validation"
    [ngClass]="{'input-field-invalid': isInvalid()}">
    <label *ngIf="!isFloatLabel"
        class="label"
        [attr.for]="id"
        [ngClass]="{
            required: required && isShowRequiredAsterisk,
            'label-invalid': isInvalid()
        }">
        {{ label | translate }}
    </label>
    <p-progressSpinner
        styleClass="progress-spinner"
        strokeWidth="8"
        animationDuration=".5s"
        *ngIf="isShowLoading">
    </p-progressSpinner>
    
    <ng-content select="[inputfield]"></ng-content>
    
    <br *ngIf="isFloatLabel" />
    <p-floatlabel>
        <ng-content select="[inputfieldFloatLabel]"></ng-content>
        <label for="tipoInstituicao" class="float-label !text-base">
            {{label | translate}}
        </label>
    </p-floatlabel>
    <small class="block text-red-700" *ngIf="isInvalid()">
        {{ msg | translate : paramsMsg }}
    </small>
    <small class="block text-gray-700" *ngIf="isCounter">
        {{'labels.caracteresRestantes' | translate}} <b>{{ counterChars() }}</b>
    </small>
</div>
